import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossedOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m18.244 19.517 3.486 3.486 1.273-1.273L2.273 1 1 2.273 6.418 7.69c-1.63.386-1.922 1.472-1.922 4.305 0 3.938.563 4.5 4.5 4.5q.232 0 .45-.002c1.39.936 2.79 1.86 4.186 2.788 2.2 1.465 3.3 2.197 4.082 1.364.246-.262.415-.63.53-1.129m-1.606-1.606L8.04 9.312a7.6 7.6 0 0 0-1.075.103c-.404.076-.474.146-.55.55-.081.43-.119 1.06-.119 2.031 0 .97.038 1.601.119 2.031.076.405.146.475.55.551.43.081 1.06.118 2.031.118q.495-.001.988-.01c1.543 1.04 3.096 2.067 4.645 3.098.619.412 1.234.843 1.888 1.198.068-.353.098-.713.12-1.071m1.858-3.228-1.8-1.8V9.891c0-1.602.127-3.295-.179-4.88-.654.355-1.269.785-1.888 1.198l-2.767 1.84-1.299-1.299q1.534-1.022 3.069-2.04c2.2-1.464 3.3-2.197 4.082-1.363.782.833.782 2.737.782 6.544z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
SpeakerCrossedOutlinedSize24Glyph.displayName = 'SpeakerCrossedOutlinedSize24Glyph';
